define([
	'internal_util/Util',
	'internal_util/UiUtil',
	'amdi18n-loader?!identity/nls/IdentityButtonView_strings',
        'amdi18n-loader?!state/nls/PrivacyPolicyState_strings',
        'amdi18n-loader?!state/nls/IdentityCreationState_strings',
	'lib/jquery'
], function (
	Util,
	UiUtil,
	Strings,
        PrivacyStrings,
        CreationStrings,
	jQuery
) {
	'use strict';

	/**
	 * NoIdentityButtonView class
	 */
	return function (password, fido_u2f, browser) {
		var _view;

		_view = (function () {
			var $view = jQuery(
					'<div id="skIdS_identity-button-container">' +
						'<button id="skIdS_show-buttons-button" type="button" class="btn btn-default"></button>' +
						'<div>' +
//							'<button id="skIdS_bind_password-button" type="button" class="btn btn-default skIdS_identity-button"></button>' +
							'<button id="skIdS_bind_fido_u2f-button" type="button" class="btn btn-default skIdS_identity-button"></button>' +
							'<button id="skIdS_bind_browser-button" type="button" class="btn btn-default skIdS_identity-button"></button>' +
						'</div>' +
					'</div>');

			$view.find('.skIdS_identity-button').on('click', function () {
				$view.find('.skIdS_identity-button').removeClass('skIdS_identity-button-active');
				jQuery(this).addClass('skIdS_identity-button-active');
			});

			$view.find('#skIdS_show-buttons-button')
				.text(Strings.show_buttons)
				.on('click', function () {
					toggleButtons();
				});

			$view.find('#skIdS_bind_fido_u2f-button')
				.text("TODO: FIDO/U2F")
				.on('click', function () {
					toggleButtons();
					Util.callCallbacks(fido_u2f);
				});

			$view.find('#skIdS_bind_browser-button')
				.text("TODO: Browser/CryptoAPI")
				.on('click', function () {
					toggleButtons();
					Util.callCallbacks(browser);
				});

			return $view;
		})();


		// private methods

		function toggleButtons() {
			if (_view.find('#skIdS_show-buttons-button').is(':visible')) {
				UiUtil.scrollTo(_view);

				_view.children().last().toggleClass('skIdS_shown');
			}
		}


		// public methods

		this.get = function () {
			return _view;
		};

		this.removeActiveStates = function () {
			_view.find('button').removeClass('skIdS_identity-button-active');
		};

		this.hideButtonMenu =  function () {
			if (_view.find('#skIdS_show-buttons-button').is(':visible')
					&& _view.children().last().hasClass('skIdS_shown')) {
				_view.children().last().removeClass('skIdS_shown');
			}
		};

		this.update = function (identity, canCreate) {
			
		};
	};
});



//////////////////
// WEBPACK FOOTER
// ./src/main/web/js/app/view/bindings/BindingButtonView.js
// module id = 361
// module chunks = 1